export function getAssignments(state, getters) {
  return state.assignments[getters.getSelectedClassId];
}

export function getAssignmentStats(state, getters) {
  return state.assignmentStats[getters.getSelectedClassId];
}

export function getClasses(state) {
  return state.classes;
}

export function getSelectedClassId(state) {
  return state.classId || 0;
}

export function getAssignmentPosition(state, getters) {
  return state.assignmentPosition[getters.getSelectedClassId];
}



// WEBPACK FOOTER //
// ./src/app/cat-assignment/store/getters.js